import * as React from 'react';
import Box from '@mui/material/Box';
import { NumberField } from '@base-ui/react/number-field';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@base-ui/react/number-field": { NumberField }, "@mui/material/IconButton": IconButton, "@mui/material/FormControl": FormControl, "@mui/material/FormHelperText": FormHelperText, "@mui/material/OutlinedInput": OutlinedInput, "@mui/material/InputAdornment": InputAdornment, "@mui/material/InputLabel": InputLabel, "@mui/icons-material/KeyboardArrowUp": KeyboardArrowUpIcon, "@mui/icons-material/KeyboardArrowDown": KeyboardArrowDownIcon } } });
export default ClientProvider;
